const NAME = "TYPES_OF_BENEFITS";

export default NAME;
